export const FETCH_DASHBOARD_HEADER_DATA='FETCH_DASHBOARD_HEADER_DATA';
export const FETCH_DASHBOARD_SURVEY_RESPONSE='FETCH_DASHBOARD_SURVEY_RESPONSE';

export const STORE_POST_OBJECT_DATE_STRING='STORE_POST_OBJECT_DATE_STRING';
export const ON_CHANGE_DATE_PICKER='ON_CHANGE_DATE_PICKER'